import { z } from "zod";

export const WorkflowFormSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  status: z.enum(["ACTIVE", "INACTIVE"]),
  steps: z.array(
    z.object({
      id: z.string(),
      type: z.enum(["TRIGGER", "ACTION"]),
      ressource: z.string(),
      operation: z.string(),
      parameters: z.object({
        status: z.array(z.string()),
        resolution: z.array(z.string()),
        reason: z.array(z.string()),
        users: z.array(z.string()),
        tags: z.string().nullable().optional(),
        additionnalNote: z
          .object({
            name: z.string(),
            value: z.string(),
          })
          .nullable()
          .optional(),
        customFields: z.array(
          z.object({
            id: z.string(),
            value: z.string(),
          }),
        ),
        note: z.string().optional().nullable(),
        mail: z
          .object({
            subject: z.string(),
            body: z.string(),
            recipients: z.array(z.string()),
          })
          .nullable()
          .optional(),
      }),
    }),
  ),
  trigger: z.object({
    id: z.string(),
    type: z.enum(["TRIGGER", "ACTION"]),
    ressource: z.string(),
    operation: z.string(),
    parameters: z.object({
      status: z.array(z.string()),
      resolution: z.array(z.string()),
      reason: z.array(z.string()),
      users: z.array(z.string()),
      tags: z.string().nullable().optional(),
      additionnalNote: z
        .object({
          name: z.string(),
          value: z.string(),
        })
        .nullable()
        .optional(),
      customFields: z.array(
        z.object({
          id: z.string(),
          value: z.string(),
        }),
      ),
      note: z.string().nullable().optional(),
      mail: z
        .object({
          subject: z.string(),
          body: z.string(),
          recipients: z.array(z.string()),
        })
        .nullable()
        .optional(),
    }),
  }),
});

export type EditWorkflowFormValues = z.infer<typeof WorkflowFormSchema>;
